import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatKey',
    standalone: false
})
export class FormatKeyPipe implements PipeTransform {
    transform(value: unknown): string {
        if (typeof value !== 'string') return '';
        return value?.toUpperCase().replace('_', ' ') || '';
    }
}

